<template>
    <Button v-bind="$props" color="black" variant="border" :font="font">
        <slot />
    </Button>
</template>

<script lang="ts">
    import { defineComponent, computed } from 'vue';
    import Button, { buttonProps } from './Button.vue';

    export default defineComponent({
        name: 'ButtonSecondary',
        components: { Button },
        props: buttonProps,
        setup(props) {
            const font = computed(() => {
                switch (props.size) {
                    case 'l':
                        return 'font-button-large';
                    case 'm':
                        return 'font-button-medium';
                    default:
                        return 'font-button-small';
                }
            });

            return { font };
        },
    });
</script>
